module.exports = __webpack_public_path__ + "static/media/romanticos_feminino_acessorios.993116a2.jpg";